@if (ds().orgUser) {
  <div class="balance-wrapper">
    <mat-card class="credits" appearance="raised">
      <mat-card-header>
        <mat-card-title>Huidig aantal credits</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p class="credit-text">
          {{ ds().orgUser.credits ?? 0 }}
        </p>
      </mat-card-content>
    </mat-card>
    <mat-card class="payment-plan" appearance="raised">
      <mat-card-header>
        <mat-card-title>Betaalplan</mat-card-title>
      </mat-card-header>
      <div class="payment-plan-wrapper">
        <div class="payment-plan">
          <p class="title">
            {{ ds().orgUser.currentPlan ? ds().orgUser.currentPlan.name : 'Geen betaalplan' }}
          </p>
        </div>
        <button
          class="action"
          mat-icon-button
          [attr.aria-label]="ds().orgUser.currentPlan ? 'Betaalplan bewerken' : 'Betaalplan toevoegen'"
          [matTooltip]="ds().orgUser.currentPlan ? 'Betaalplan bewerken' : 'Betaalplan toevoegen'"
          (click)="ds().orgUser.currentPlan ? editPlan() : router.navigate(['/pay'])"
        >
          <mat-icon>{{ ds().orgUser.currentPlan ? 'edit' : 'add' }}</mat-icon>
        </button>
      </div>
    </mat-card>
    @if (orgUserHistory()) {
      <mat-card appearance="raised" class="history">
        <mat-card-header>
          <mat-card-title>Historie</mat-card-title>
        </mat-card-header>
        <div class="history-table-wrapper">
          <table mat-table [dataSource]="orgUserHistory()">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <ng-container matColumnDef="credits">
              <th mat-header-cell *matHeaderCellDef>Credits</th>
              <td mat-cell *matCellDef="let element">
                @if (element.creditsAdded) {
                  <span class="positive"> +{{ element.creditsAdded }} </span>
                }
                @if (element.creditsSpent) {
                  <span class="negative"> -{{ element.creditsSpent }} </span>
                }
                @if (!element.creditsSpent && !element.creditsAdded) {
                  <span class="sepa"> N.V.T </span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Beschrijving</th>
              <td mat-cell *matCellDef="let element">
                {{ element.description }}
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Datum</th>
              <td mat-cell *matCellDef="let element">
                {{ element.date.toDate() | date: 'dd-MM-yyyy HH:mm' }}
              </td>
            </ng-container>
          </table>
        </div>
      </mat-card>
    }
  </div>
}
